<!-- 月票是否可购买/续费 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN61D2",
                "monthTicketTypeId": 1,
                "monthTicketId": 1,
                "plateLists": [
                    {
                        "plate": "宁A66666",
                        "plateColor": 1
                    }
                ],
                "timePeriods": {
                    "startTime": "20230601",
                    "endTime": "20230630"
                },
                "mobile": "13000000000"
            },
            responseCode: {
                "data": {
                    "code": 200,
                    "message": "可开通"
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台 判断是否可以开通/续费指定月票",
                t_url: this.commonUrls.test+"allowBuyMonthlyTicket",
                p_url: this.commonUrls.prod+"allowBuyMonthlyTicket",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                          { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                          { info1: 'monthTicketTypeId', info2: '是', info3: 'Long', info4: '月票类型ID' },
                          { info1: 'monthTicketId', info2: '否', info3: 'Long', info4: '月票ID，不为空时为续费，为空时为开通' },
                          { info1: 'plateLists', info2: '否', info3: 'JSONArray', info4: '月票车牌信息，开通时必填' },
                          { info1: 'timePeriods', info2: '是', info3: 'JSONObject', info4: '月票有效时间' },
                          { info1: 'mobile', info2: '否', info3: 'String', info4: '手机号码，11位，需要月票凭证时必填' },
                        ]
                },{
                    titleName: 'plateLists',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                          { info1: 'plate', info2: '是', info3: 'String', info4: '车牌号码' },
                          { info1: 'plateColor', info2: '否', info3: 'Long', info4: '车牌颜色  0其他，1蓝色，2黄色，3白色，4黑色，5绿色（暂时不支持指定颜色）' },
                        ]
                },{
                    titleName: 'timePeriods',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                          { info1: 'startTime', info2: '是', info3: 'String', info4: '月票有效开始时间yyyyMMdd' },
                          { info1: 'endTime', info2: '是', info3: 'String', info4: '月票有效结束时间yyyyMMdd' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'code', info2: '是', info3: 'Integer', info4: '状态码，200可开通 其它<url>参考附录:/Api/appendixData#appendixData_8</url>' },
                        { info1: 'msg', info2: '是', info3: 'String', info4: '结果说明' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/query/allowBuyMonthlyTicket.vue